import type { UUID } from '@/utils/uuid';

export const sensitiveContentQueryKeys = {
  list: (tenantId?: UUID) => ['sensitive-content', tenantId] as const,
  /** Under the list key, so refreshing the list refreshes these too. */
  row: (tenantId?: UUID, connectorId?: UUID, id?: string) =>
    ['sensitive-content', tenantId, 'row', connectorId, id] as const,
  runResult: (
    tenantId?: UUID,
    connectorId?: UUID,
    featureId?: UUID,
    runSequence?: number
  ) =>
    [
      'sensitive-content',
      tenantId,
      'run-result',
      connectorId,
      featureId,
      runSequence,
    ] as const,
};

export const sensitiveContentMutationKeys = {
  reveal: (tenantId?: UUID) =>
    ['sensitive-content', 'reveal', tenantId] as const,
  promote: (tenantId?: UUID) =>
    ['sensitive-content', 'promote', tenantId] as const,
};
